export const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 }
};

export const pageTransition = {
  duration: 0.32,
  ease: 'easeOut'
};

export const pageTransitionSlow = {
  duration: 0.35,
  ease: 'easeOut'
};
